<template>
  <div id="app">

    <router-view></router-view>
     
  </div>
</template>

<script>

export default {
  name: "app",
  components: {
    // selectorPedidos
  },
  data() {
    return {
      verSelector: true//(process.env.NODE_ENV == "development") ? true : false
    }
  },
};
</script>

<style >

html {
  overflow: hidden;
  
}
body
{
  height: -webkit-fill-available;
  overflow-y: hidden;
  overflow-x: hidden;
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222;
  word-break: break-word !important;
  height: 595px;
font-size: 13.5px;
font-size-adjust: 15px;
  border: none;
  background: transparent;

  padding: 0 !important;
  margin: 0;
   /* overflow-y: scroll; */
    overflow-x: hidden;
  
}
@media screen and (max-width: 768px) {
  body, html {
     min-height: -webkit-fill-available;
     height: 100%;
  }
}
</style>
